export default {
  RESETSTATE: 'RESETSTATE',
  LOGIN: 'LOGIN',
  INITIALIZE_LOCATIONS: 'INITIALIZE_LOCATIONS',
  REFRESH_TOKENS: 'REFRESH_TOKENS',
}
